import React from "react";

import Input, { InputProps } from "@mui/material/Input";

const TagInput = React.forwardRef<HTMLInputElement, InputProps>(
  (props, ref) => (
    <Input
      {...props}
      ref={ref}
      disableUnderline
      inputProps={{ maxLength: 50 }}
    />
  )
);

TagInput.displayName = "TagInput";

export default TagInput;
